require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-which-coding-language-should-i-learn-first.json") })
        }
      }, "path---blog-which-coding-language-should-i-learn-first");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-which-coding-language-should-i-learn-first!./.cache/json/blog-which-coding-language-should-i-learn-first.json
// module id = 1133
// module chunks = 231608221292675